export default "__VITE_ASSET__DYJzsuTw__"